import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CommentarySection
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/CommentarySection';
import HighlightHeader
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/HighlightHeader';
import PerformanceSection
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/Sections/PerformanceSection';
import { getSectionCardStyle } from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/styles';
import UserFeedback from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedback';
import fr from 'facet-rest';

const styles = (theme) => ({
  root: {
    ...getSectionCardStyle({ theme }),
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    height: '100%',
  },
});

const HighlightedCommentaryCard = ({
  className,
  classes,
  label,
  startDate,
  endDate,
  performance,
  benchmark,
  commentary,
  lastUpdated,
  chartData,
  showBenchmark,
  onClickDateRange,
  feedbackLink,
  handleOnFeedbackSubmitted,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <HighlightHeader label={label} startDate={startDate} endDate={endDate} chartData={chartData} onClickDateRange={onClickDateRange} />
      <PerformanceSection benchmark={benchmark} performance={performance} showBenchmark={showBenchmark} />
      <CommentarySection commentary={commentary} lastUpdated={lastUpdated} />
      {feedbackLink && <UserFeedback link={feedbackLink} handleOnFeedbackSubmitted={handleOnFeedbackSubmitted} />}
    </Box>
  );
};

HighlightedCommentaryCard.defaultProps = {
  className: '',
  chartData: undefined,
  showBenchmark: true,
  onClickDateRange: undefined,
  feedbackLink: undefined,
  handleOnFeedbackSubmitted: undefined,
};

HighlightedCommentaryCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  performance: PropTypes.string.isRequired,
  benchmark: PropTypes.string.isRequired,
  commentary: PropTypes.string.isRequired,
  chartData: PropTypes.array,
  lastUpdated: PropTypes.string.isRequired,
  showBenchmark: PropTypes.bool,
  onClickDateRange: PropTypes.func,
  feedbackLink: PropTypes.instanceOf(fr.Link),
  handleOnFeedbackSubmitted: PropTypes.func,
};

export default withStyles(styles)(HighlightedCommentaryCard);
